export const CREATE_CUSTOMER_FROM_DRAFT_REQUEST = 'CREATE_CUSTOMER_FROM_DRAFT_REQUEST';
export const CREATE_CUSTOMER_FROM_DRAFT_SUCCESS = 'CREATE_CUSTOMER_FROM_DRAFT_SUCCESS';
export const CREATE_CUSTOMER_FROM_DRAFT_FAILURE = 'CREATE_CUSTOMER_FROM_DRAFT_FAILURE';
